import { render, staticRenderFns } from "./WelcomeToVexels.vue?vue&type=template&id=3767edae&scoped=true&"
import script from "./WelcomeToVexels.vue?vue&type=script&lang=js&"
export * from "./WelcomeToVexels.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeToVexels.vue?vue&type=style&index=0&id=3767edae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3767edae",
  null
  
)

export default component.exports